"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PROMOBAR_COLOR = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));

require("./PromoBar.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const PROMOBAR_COLOR = {
  PINK: 'pink',
  BLUE: 'blue',
  PINK_LIGHT: 'pink-light'
};
exports.PROMOBAR_COLOR = PROMOBAR_COLOR;

const PromoBar = _ref => {
  let {
    components,
    backgroundColor,
    cySelector
  } = _ref;
  const bgColor = backgroundColor || PROMOBAR_COLOR.PINK_LIGHT;
  const className = `container PromoBar promoBar-bgColor-${bgColor}`;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "cy-data": cySelector,
    className: className,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, components['TextInfo-1']), {}, {
      className: "promoBarTextInfo"
    }))
  });
};

PromoBar.propTypes = {
  /**
   * {
   *  "info": "Estructura de componentes de PromoBar",
   *  "kind": "both",
   *  "beautifulName": "subcomponentes de promobar"
   * }
   */
  components: _propTypes.default.shape({
    'TextInfo-1': _propTypes.default.object.isRequired
  }).isRequired,

  /**
   * {
   *  "info": "Especifica el color de fondo de dicha banda",
   *  "kind": "both",
   *  "beautifulName": "Color de fondo"
   * }
   */
  backgroundColor: _propTypes.default.string,

  /**
   * {
   *  "info": "Selector cy para cy-data",
   *  "kind": "both",
   *  "beautifulName": "Color de fondo"
   * }
   */
  cySelector: _propTypes.default.string
};
PromoBar.defaultProps = {
  backgroundColor: PROMOBAR_COLOR.PINK,
  cySelector: ''
};
var _default = PromoBar;
exports.default = _default;

//# sourceMappingURL=index.js.map